import { LayerGroup } from 'react-leaflet';
import L from 'leaflet';
import proj4 from 'proj4';
import { useEffect, useRef } from 'react';

proj4.defs("EPSG:28992", "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +no_defs");

function RDGridLayer() {
    const layerRef = useRef(null);

    useEffect(() => {
        const gridLayer = L.layerGroup();
        const currentLayerRef = layerRef.current;
        const color= process.env.REACT_APP_PRIMARYCOLOR || 'blue';

        const minX = 0;
        const maxX = 280000;
        const minY = 300000;
        const maxY = 620000;
        const step = 1000;

        for (let x = minX; x <= maxX; x += step) {
            const start = proj4("EPSG:28992", "EPSG:4326", [x, minY]);
            const end = proj4("EPSG:28992", "EPSG:4326", [x, maxY]);
            gridLayer.addLayer(L.polyline([[start[1], start[0]], [end[1], end[0]]], {
                color: color, weight: 1, opacity: 0.5
            }));
        }

        for (let y = minY; y <= maxY; y += step) {
            const start = proj4("EPSG:28992", "EPSG:4326", [minX, y]);
            const end = proj4("EPSG:28992", "EPSG:4326", [maxX, y]);
            gridLayer.addLayer(L.polyline([[start[1], start[0]], [end[1], end[0]]], {
                color: color, weight: 1, opacity: 0.5
            }));
        }


        if (layerRef.current) {
            gridLayer.eachLayer(layer => layerRef.current.addLayer(layer));
        }
        return () => {
            if (currentLayerRef) {
                currentLayerRef.clearLayers();
            }
        };
    }, []);

    return <LayerGroup ref={layerRef} />

}

export default RDGridLayer;
